export default __webpack_public_path__ + "static/media/icon_question_h.e975ebea.png";